const metaData = {
  titleEnd: {
    de: 'Wetterversicherung schnell, einfach und digital',
    en: 'Weather insurance fast, easy and digital',
    pl: 'Weather insurance fast, easy and digital',
  },
  main: {
    de: {
      title: 'Regenversicherung im Urlaub - Schutz bei schlechtem Wetter',
      description: 'Schützen Sie Ihren Urlaub mit unserer Regenversicherung. Finanzielle Absicherung bei Regen, Unwetter oder wetterbedingt ruinierten Urlaubstagen. Jetzt informieren!',
    },
    en: {
      title: 'Weather guarantee insurance, rainy day cover insurance, rain insurance, weather insurance for travel',
      description: 'Insure your vacation and travel against rain',
    },
    pl: {
      title: 'Weather guarantee insurance, rainy day cover insurance, rain insurance, weather insurance for travel',
      description: 'Insure your vacation and travel against rain',
    },
  },
  createNewVacationContract: {
    de: {
      title: 'Neuen Urlaubskontrakt erstellen',
    },
    en: {
      title: 'Create a new vacation contract',
    },
    pl: {
      title: 'Create a new vacation contract',
    },
  },
  vacation: {
    de: {
      title: 'Regenversicherung im Urlaub - Schutz bei schlechtem Wetter',
      description: 'Schützen Sie Ihren Urlaub mit unserer Regenversicherung. Finanzielle Absicherung bei Regen, Unwetter oder wetterbedingt ruinierten Urlaubstagen. Jetzt informieren!',
    },
    en: {
      title: 'Weather guarantee insurance, rainy day cover insurance, rain insurance, weather insurance for travel',
      description: 'Insure your vacation and travel against rain',
    },
    pl: {
      title: 'Weather guarantee insurance, rainy day cover insurance, rain insurance, weather insurance for travel',
      description: 'Insure your vacation and travel against rain',
    },
  },
  regenversicherungUrlaub: {
    de: {
      title: 'Regenversicherung im Urlaub - Schutz bei schlechtem Wetter',
      description: 'Schützen Sie Ihren Urlaub mit unserer Regenversicherung. Finanzielle Absicherung bei Regen, Unwetter oder wetterbedingt ruinierten Urlaubstagen. Jetzt informieren!',
    },
    en: {
      title: 'Weather guarantee insurance, rainy day cover insurance, rain insurance, weather insurance for travel',
      description: 'Insure your vacation and travel against rain',
    },
    pl: {
      title: 'Weather guarantee insurance, rainy day cover insurance, rain insurance, weather insurance for travel',
      description: 'Insure your vacation and travel against rain',
    },
  },
  dertourRegenversicherung: {
    de: {
      title: 'Urlaubsversicherung',
      description: 'Versichern Sie Ihren Urlaub gegen Regen.',
    },
    en: {
      title: 'Vacation insurance',
      description: 'Insure your vacation against rain',
    },
    pl: {
      title: 'Vacation insurance',
      description: 'Insure your vacation against rain',
    },
  },
  hotel: {
    de: {
      title: 'Hotel gegen Regen versichern',
      description: 'Versichern Sie ihr Hotel gegen regnerische Perioden, in denen weniger Gäste kommen und der Umsatz wegbleibt.',
    },
    en: {
      title: 'Insure your hotel against rain',
      description: '',
    },
    pl: {
      title: 'Insure your hotel against rain',
      description: 'Create a new vacation contract',
    },
  },
  drought: {
    de: {
      title: 'Dürreversicherung',
      description: 'Dürre versichern für Landwirtschaft und Acker.',
    },
    en: {
      title: 'Drought insurance',
      description: 'Insure drought for agriculture and fields',
    },
    pl: {
      title: 'Drought insurance',
      description: 'Insure drought for agriculture and fields',
    },
  },
  droughtNoCommitment: {
    de: {
      title: 'Dürreversicherung',
      description: 'Versichern Sie Ihr Feld gegen fehlenden Regen.',
    },
    en: {
      title: 'Drought insurance',
      description: 'Insure your field against drought',
    },
    pl: {
      title: 'Drought insurance',
      description: 'Insure your field against drought',
    },
  },
  rain: {
    de: {
      title: 'Regenversicherung',
      description: 'Versichern Sie Ihr Geschäft gegen Regenfall.',
    },
    en: {
      title: 'Insurance against rain',
      description: 'Insure your business against rain',
    },
    pl: {
      title: 'Insurance against rain',
      description: 'Insure your business against rain',
    },
  },
  custom: {
    de: {
      title: 'Gegen Temperatur oder Schnee versichern',
      description: 'Versichern Sie Ihr Geschäft gegen hohe oder niedrige Temperatur sowie Schnee oder fehlenden Schnee.',
    },
    en: {
      title: 'Insurance against temperature or snow',
      description: 'Insure your business against high or low temperature or against snow or lack of snow.',
    },
    pl: {
      title: 'Insurance against temperature or snow',
      description: 'Insure your business against high or low temperature or against snow or lack of snow.',
    },
  },
  settings: {
    de: {
      title: 'Einstellungen',
    },
    en: {
      title: 'settings',
    },
    fr: {
      title: 'Mon profil',
    },
    pl: {
      title: 'settings',
    },
  },
  insurance: {
    de: {
      title: 'Meine Versicherungen',
    },
    en: {
      title: 'My Insurances',
    },
    fr: {
      title: 'Mes contrats',
    },
    pl: {
      title: 'My Insurances',
    },
  },
  insuranceId: {
    de: {
      title: 'Versicherungsübersicht',
    },
    en: {
      title: 'Insurance overview',
    },
    fr: {
      title: "Vos données de contrat",
    },
    pl: {
      title: 'Insurance overview',
    },
  },
  guarantee: {
    en: {
      title: 'My Weather Protections',
    },
  },
  guaranteeId: {
    en: {
      title: 'Weather Protection Overview',
    },
  },
  droughtRisk: {
    de: {
      title: 'Ihr Dürrerisiko',
    },
    en: {
      title: 'Your drought risk',
    },
    pl: {
      title: 'Calculate drought risk',
    },
  },
  cropSelection: {
    de: {
      title: 'Dürrerisiko berechnen',
      description: 'Nutzen Sie unseren Rechner, um Ihr Dürrerisiko zu berechnen.',
    },
    en: {
      title: 'Calculate drought risk',
      description: 'Use our calculator to calculate your drought risk.',
    },
    pl: {
      title: 'Calculate drought risk',
      description: 'Use our calculator to calculate your drought risk.',
    },
  },
  cropLocation: {
    de: {
      title: 'Standort Ihres Ackers',
    },
    en: {
      title: 'Location of your fields',
    },
    pl: {
      title: 'Location of your fields',
    },
  },
  doneBundle: {
    de: {
      title: 'Fast fertig',
    },
    en: {
      title: 'Almost Done',
    },
    pl: {
      title: 'Almost Done',
    },
  },
  location: {
    de: {
      title: 'Wählen Sie ihren Versicherungstandort',
    },
    en: {
      title: 'Choose your insurance location',
    },
    pl: {
      title: 'Choose your insurance location',
    },
  },
  done: {
    de: {
      title: 'Fast fertig',
    },
    en: {
      title: 'Almost Done',
    },
    pl: {
      title: 'Almost Done',
    },
  },
  additional: {
    de: {
      title: 'Bitte weitere Informationen eingeben',
    },
    en: {
      title: 'Please fill out the additional information',
    },
    pl: {
      title: 'Please fill out the additional information',
    },
  },
  buy: {
    de: {
      title: 'Versicherung abschließen',
    },
    en: {
      title: 'Contract overview',
    },
    pl: {
      title: 'Contract overview',
    },
  },
  buyVacation: {
    de: {
      title: 'Vertragsübersicht',
    },
    en: {
      title: 'Contract overview',
    },
    pl: {
      title: 'Contract overview',
    },
  },
  finalizeVacation: {
    de: {
      title: 'Regenversicherung für Urlaub fertigstellen',
    },
    en: {
      title: 'Finalize rain insurance for vacation',
    },
    pl: {
      title: 'Finalize rain insurance for vacation',
    },
  },
  login: {
    de: {
      title: 'Einloggen',
    },
    en: {
      title: 'Login',
    },
    fr: {
      title: 'Connexion',
    },
    pl: {
      title: 'Login',
    },
  },
  signup: {
    de: {
      title: 'Registrieren',
    },
    en: {
      title: 'Sign up',
    },
    pl: {
      title: 'Sign up',
    },
  },
  success: {
    de: {
      title: 'Kauf abgeschlossen',
    },
    en: {
      title: 'Insurance bought',
    },
    pl: {
      title: 'Insurance bought',
    },
  },
  letus: {
    de: {
      title: 'Sie erhalten Ihr Angebot sofort auf der nächsten Seite',
    },
    en: {
      title: 'You will receive your offer immediately on the next page',
    },
    pl: {
      title: 'You will receive your offer immediately on the next page',
    },
  },
  forgot: {
    de: {
      title: 'Passwort vergessen',
    },
    en: {
      title: 'Forgot password',
    },
    fr: {
      title: 'Mot de passe oublié',
    },
    pl: {
      title: 'Forgot password',
    },
  },
  passwordReset: {
    de: {
      title: 'Passwort zurücksetzen',
    },
    en: {
      title: 'reset password',
    },
    fr: {
      title: 'Reinitialise le mot de passe',
    },
    pl: {
      title: 'reset password',
    },
  },
};

export default metaData;
